<template lang="pug">
  .orders
    el-row
      el-col(:span="12")
        el-form(:inline="true")
          el-form-item(label="上架状态")
            el-select(v-model="pageModel.condition.status", @change="query(1)")
              el-option(label="全部", value="all")
              el-option(label="已上架", value="1")
              el-option(label="已下架", value="0")
      el-col(:span="12")
        el-button(type="primary", @click="toForm") 添加商品
    el-table(:data="goods", stripe)
      el-table-column(label="排序")
        template(slot-scope="scope")
          div(v-if="modifySortGood === scope.row._id")
            el-input-number(v-model="scope.row.sort", label="数值越大越靠前", size="mini", controls-position="right")
            el-button(type="primary", size="mini", @click="handleSaveSort(scope.row)", round) 保存
          div(v-else)
            span {{scope.row.sort}}
            i.link.el-icon-edit(@click="modifySortGood = scope.row._id")
      el-table-column(label="更新日期")
        template(slot-scope="scope")
          span {{$moment(scope.row.update_date).calendar()}}
      el-table-column(label="封面图")
        template(slot-scope="scope")
          el-image.cover-image(
            :src="`https://tlhw.oss-cn-shanghai.aliyuncs.com/${scope.row.cover_image}!414_jpeg_zoom`",
            fit="cover",
            :preview-src-list="[`https://tlhw.oss-cn-shanghai.aliyuncs.com/${scope.row.cover_image}!414_jpeg_zoom`]"
          )
      el-table-column(prop="name", label="商品")
      el-table-column(prop="coin", label="陀螺币")
        template(slot-scope="scope")
          span {{scope.row.coin}}
          i.link.el-icon-edit(@click="handleCoinModify(scope.row)")
      el-table-column(label="销量")
        template(slot-scope="scope")
          span {{scope.row.sales_count}}
          //- i.link.el-icon-refresh(@click="handleSalesSync(scope.row)")
      el-table-column(label="虚拟销量")
        template(slot-scope="scope")
          span {{scope.row.v_sales_count}}
          i.link.el-icon-edit(@click="handleVisualSalesModify(scope.row)")
      el-table-column(label="兑换规则分组")
        template(slot-scope="scope")
          span(v-if="scope.row.intentional_order_rule_group") {{scope.row.intentional_order_rule_group.name}}
          i.link.el-icon-edit(@click="handleGroupModify(scope.row)")
      el-table-column(label="砍价操作")
        template(slot-scope="scope")
          el-popconfirm(v-if="scope.row.can_bargain", title="确定关闭砍价？", @onConfirm="handleUpdateCanBargain(scope.row, false)")
            el-button(slot="reference", type="primary", size="mini") 关闭砍价
          el-popconfirm(v-else, title="确定开启砍价？", @onConfirm="handleUpdateCanBargain(scope.row, true)")
            el-button(slot="reference", type="warning", size="mini") 开启砍价
      el-table-column(label="操作")
        template(slot-scope="scope")
          el-popconfirm(v-if="scope.row.status === 1", title="确定下架？", @onConfirm="handleUpdateStatus(scope.row, 0)")
            el-button(slot="reference", type="primary", size="mini") 下架
          el-popconfirm(v-else, title="确定上架？", @onConfirm="handleUpdateStatus(scope.row, 1)")
            el-button(slot="reference", type="warning", size="mini") 上架
          el-button(type="warning", @click="toForm(scope.row)") 修改商品
    el-pagination(
      background,
      :current-page="pageModel.pageNo",
      layout="prev, pager, next, total",
      :total="pageModel.total"
      @current-change="query"
    )
    IntentionalRuleGroupSelector(ref="groupSelector", :good="modifyGood._id", :group="modifyGood.intentional_order_rule_group" @saved="query")
    GoodCoinForm(ref="coinForm", :goodId="modifyGood._id", @saved="query")
    VisualSalesForm(ref="visualSalesForm", :goodId="modifyGood._id", @saved="query")
</template>

<script>
import IntentionalRuleGroupSelector from '../../components/intentional/ruleGroup.selector.vue'
import GoodCoinForm from '../../components/good/coin.form.vue'
import VisualSalesForm from '../../components/good/visualSales.form.vue'

export default {
  components: {
    IntentionalRuleGroupSelector,
    GoodCoinForm,
    VisualSalesForm
  },
  data() {
    return {
      goods: [],
      modifyGood: {},
      modifySortGood: '',
      pageModel: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        condition: {
          status: 'all'
        }
      }
    }
  },
  mounted() {
    this.query(1)
  },
  methods: {
    query(pageNo) {
      this.pageModel.pageNo = pageNo || this.pageModel.pageNo
      let _condition = {}
      if(this.pageModel.condition.status !== 'all') {
        _condition.status = this.pageModel.condition.status
      }
      this.$service.GoodService
        .query({
          pageNo: this.pageModel.pageNo,
          pageSize: this.pageModel.pageSize,
          condition: _condition
        })
        .then(res => {
          if (res.status === 200) {
            this.pageModel.total = res.data.data.total
            this.goods = res.data.data.goods
          }
        })
    },
    handleGroupModify(good) {
      this.modifyGood = good
      this.$refs.groupSelector.show()
    },
    handleCoinModify(good) {
      this.modifyGood = good
      this.$refs.coinForm.show()
    },
    handleUpdateStatus(good, status) {
      this.$service.GoodService
        .updateStatus(good._id, status)
        .then(res => {
          if (res.status === 200 && res.data.code === 0) {
            this.$message({
              message: '已更新状态',
              type: 'success'
            })
            this.query()
          }
        })
    },
    handleVisualSalesModify(good) {
      this.modifyGood = good
      this.$refs.visualSalesForm.show()
    },
    handleSalesSync(good) {
      this.$service.GoodService
        .syncSales(good._id)
        .then(() => {
          this.$message.success('销量已同步')
          this.query()
        })
    },
    handleSaveSort(good) {
      this.modifySortGood = ''
      this.$service.GoodService
        .updateSort(good._id, good.sort)
        .then(() => {
          this.query()
        })
    },
    handleUpdateCanBargain(good, canBargain) {
      this.$service.GoodService
        .updateCanBargain(good._id, canBargain)
        .then(res => {
          if (res.status === 200 && res.data.code === 0) {
            this.$message({
              message: '已更新商品砍价状态',
              type: 'success'
            })
            this.query()
          }
        })
    },
    toForm(good) {
      this.$router.push({
        name: 'goodForm',
        query: good ? { id: good._id } : undefined
      })
    }
  }
}
</script>

<style lang="less" scope>
.cover-image{
  width: 60px;
  height: 40px;
}
.link{
  cursor: pointer;
}
</style>